// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bhdJ","rootMobile":"styles_rootMobile__3h4IL"};